export var BUY_FULFILLMENT_OFFERINGS_JOBS = 'buy/fulfillment_offerings_jobs/v2';
export var BUY_FULFILLMENT_OFFERINGS = 'buy/fulfillment_offerings/v2';
export var ASYNC_JOB_TIMEOUT = 30000; // increased to 30 seconds to match expected

export var STATUS_TYPE_COMPLETED = 'COMPLETED';
/**
 * @type {object}
 * @property {string} digital - Digital fulfillment for gift cards
 * @property {string} pickupLocation - Click & Collect Location
 * @property {string} pickupPoints - Pick-Up-Point Location
 * @property {string} search - Search nearby location
 * @property {string} shipping - Shipping Address
 * @property {string} store - Store
 */

export var LOCATION_TYPES = {
  digital: 'address/digital',
  pickupLocations: 'location/pick_up_locations',
  pickupPoints: 'ship/pickup_points',
  search: 'location/search',
  shipping: 'address/shipping',
  store: 'store/store_views'
};
/**
 * @memberof ux-tread-fulfillment-offerings
 * @type {object}
 * @property {string} [digital = 'DIGITAL'] - enum for digital type
 * @property {string} [instore = 'INSTORE'] - enum for instore type
 * @property {string} [pickup = 'PICKUP'] - enum for pickup type
 * @property {string} [ship = 'SHIP'] - enum for ship type
 */

export var FULFILLMENT_TYPES = {
  digital: 'DIGITAL',
  instore: 'INSTORE',
  pickup: 'PICKUP',
  ship: 'SHIP'
};
export var SHORT_CIRCUIT_ERROR_MESSAGE = 'Short circuiting response due to client-side timeout';
export var pageActionName = 'tread-fullfillment-offerings-event';
export var GET_ERROR_FALLBACK_MESSAGE = 'Error during GET/fulfillment_offerings';
export var GET_JOB_ERROR_FALLBACK_MESSAGE = 'Error during GET/fulfillment_offerings_job';
export var PUT_JOB_ERROR_FALLBACK_MESSAGE = 'Error during PUT/fulfillment_offerings_job';
/**
 * @memberof ux-tread-fulfillment-offerings
 * @description required prop for when shipping location is to be calculated, used for shipping, passed in as input from user or from user data
 * @typedef {object} FulfillmentOfferingItemLocationPostalAddress
 * @property {string} country - country of address used for shipping
 * @property {string} address1 - 1st line of address used for shipping
 * @property {string} city - city of address used for shipping
 * @property {string} state - state of address used for shipping
 * @property {string} postalCode - postalCode of address used for shipping
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description required prop for when searching for pickup locations, used for search, passed in for search from client, browser, or edge headers
 * @typedef {object} FulfillmentOfferingItemLocationCoordinates
 * @property {number} latitude - used for searching for stores and inventory availability
 * @property {number} longitude - used for searching for stores and inventory availability
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description required prop for when searching for pickup locations, used for search based on product requirements
 * @typedef {object} FulfillmentOfferingItemLocationRadius
 * @property {number} distance - used for specifying search range when searching for stores and inventory availability
 * @property {string} unitOfMeasure - enums used for how distance is returned from search, either as miles (mi) or kilometers (km)
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description required as part of items parameter for CQRS PUT API calls
 * @typedef {object} FulfillmentOfferingItemLocation
 * @property {string} type - enum of specific types @see LOCATION_TYPES
 * @property {string} postalCode - used along with type for search to search within range of a postalCode
 * @property {FulfillmentOfferingItemLocationPostalAddress} postalAddress - used for shipping, passed in as input from user or from user data
 * @property {FulfillmentOfferingItemLocationCoordinates} coordinates - used for search, passed in for search from client, browser, or edge headers
 * @property {FulfillmentOfferingItemLocationRadius} radius - used for search based on product requirements
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description shipping address associated with item. Only used for digital gift card items
 * @typedef {object} FulfillmentOfferingItemShippingAddress
 * @property {string} email - email of recipient for digital gift card
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description required as part of items parameter passed to getAsyncFulfillmentOfferings
 * @typedef {object} FulfillmentOfferingItem
 * @property {string} id - uuid that maps to a cart item
 * @property {string} skuId - uuid specific to a size/color combination for a product
 * @property {number} quantity - number denoting quantity of item
 * @property {Array.FulfillmentOfferingItemLocation} locations - generated in this module but used for api calls
 * @property {string} fulfillmentType - string denoting which fulfillmentType to use at the item level @see FULFILLMENT_TYPES
 * @property {FulfillmentOfferingItemShippingAddress} shippingAddress - object containing email, used for digital gift cards
 */

/**
 * @memberof ux-tread-fulfillment-offerings
 * @description optional parameter for filtering search location types.
 * @typedef {object} FulfillmentOfferingSearchFilter
 * @property {string} locationType - the type of location for the locationId, required if locationId is present, store/store_views, ship/pickup_points
 * @property {number} count - limit search from between 0 to 20
 */